
import { Component, Vue, Watch } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import {
  get1stAndToday,
  past7Day,
  past30Day,
  pastWeek,
  pastMonth,
} from '@/utils/formValidate'
import {
  getTurnoverStatistics,
  getUserStatistics,
  getOrderStatistics,
  getTop,
} from '@/api/index'
import TitleIndex from './components/titleIndex.vue'
import TurnoverStatistics from './components/turnoverStatistics.vue'
import UserStatistics from './components/userStatistics.vue'
import OrderStatistics from './components/orderStatistics.vue'
import Top from './components/top10.vue'

@Component({
  name: 'StatisticsDashboard',
  components: {
    TitleIndex,
    TurnoverStatistics,
    UserStatistics,
    OrderStatistics,
    Top,
  },
})
export default class extends Vue {
  private overviewData = {} as any
  private flag = 2
  private tateData: any[] = []
  private dateBegin = ''
  private dateEnd = ''
  private turnoverData = {} as any
  private userData = {}
  private orderData = { data: {} } as any
  private top10Data = {}
  private fetchGeneration = 0

  get currentStoreId(): string {
    return UserModule.storeId || ''
  }

  get chartScopeKey(): string {
    const sid = this.currentStoreId || 'platform'
    return `${sid}-${this.dateBegin}-${this.dateEnd}`
  }

  created() {
    this.getTitleNum(2)
  }

  @Watch('currentStoreId')
  private onStoreIdChange(val: string, oldVal: string) {
    if (oldVal === undefined) return
    if (val === oldVal) return
    this.reloadAll()
  }

  private reportStoreId(): number | undefined {
    const id = this.currentStoreId
    if (!id) return undefined
    const n = Number(id)
    return Number.isNaN(n) ? undefined : n
  }

  private reloadAll() {
    this.turnoverData = { dateList: [], turnoverList: [], nonWalletTurnoverList: [] }
    this.userData = {}
    this.orderData = { data: {} }
    this.top10Data = { nameList: [], numberList: [] }
    if (this.dateBegin && this.dateEnd) {
      this.init(this.dateBegin, this.dateEnd)
    } else {
      this.getTitleNum(this.flag)
    }
  }

  init(begin: any, end: any) {
    this.dateBegin = begin
    this.dateEnd = end
    const storeId = this.reportStoreId()
    const gen = ++this.fetchGeneration
    this.$nextTick(() => {
      this.getTurnoverStatisticsData(begin, end, gen, storeId)
      if (!storeId) {
        this.getUserStatisticsData(begin, end, gen)
      }
      this.getOrderStatisticsData(begin, end, gen, storeId)
      this.getTopData(begin, end, gen, storeId)
    })
  }

  async getTurnoverStatisticsData(
    begin: any,
    end: any,
    gen: number,
    storeId?: number,
  ) {
    const data = await getTurnoverStatistics({ begin, end, storeId })
    if (gen !== this.fetchGeneration) return
    const turnoverData = data.data.data
    this.turnoverData = {
      dateList: turnoverData.dateList.split(','),
      turnoverList: turnoverData.turnoverList.split(','),
      nonWalletTurnoverList: (turnoverData.nonWalletTurnoverList || '')
        .split(',')
        .filter((s: string) => s !== ''),
    }
  }

  async getUserStatisticsData(begin: any, end: any, gen: number) {
    const data = await getUserStatistics({ begin, end })
    if (gen !== this.fetchGeneration) return
    const userData = data.data.data
    this.userData = {
      dateList: userData.dateList.split(','),
      totalUserList: userData.totalUserList.split(','),
      newUserList: userData.newUserList.split(','),
    }
  }

  async getOrderStatisticsData(
    begin: any,
    end: any,
    gen: number,
    storeId?: number,
  ) {
    const data = await getOrderStatistics({ begin, end, storeId })
    if (gen !== this.fetchGeneration) return
    const orderData = data.data.data
    this.orderData = {
      data: {
        dateList: orderData.dateList.split(','),
        orderCountList: orderData.orderCountList.split(','),
        validOrderCountList: orderData.validOrderCountList.split(','),
      },
      totalOrderCount: orderData.totalOrderCount,
      validOrderCount: orderData.validOrderCount,
      orderCompletionRate: orderData.orderCompletionRate,
    }
  }

  async getTopData(begin: any, end: any, gen: number, storeId?: number) {
    const data = await getTop({ begin, end, storeId })
    if (gen !== this.fetchGeneration) return
    const top10Data = data.data.data
    this.top10Data = {
      nameList: top10Data.nameList.split(',').reverse(),
      numberList: top10Data.numberList.split(',').reverse(),
    }
  }

  getTitleNum(data: number) {
    this.flag = data
    switch (data) {
      case 1:
        this.tateData = get1stAndToday()
        break
      case 2:
        this.tateData = past7Day()
        break
      case 3:
        this.tateData = past30Day()
        break
      case 4:
        this.tateData = pastWeek()
        break
      case 5:
        this.tateData = pastMonth()
        break
      default:
        this.tateData = past7Day()
    }
    const begin = this.tateData[0]
    const end = this.tateData[this.tateData.length - 1]
    this.init(begin, end)
  }
}
